module.exports = __webpack_public_path__ + "static/media/schools_slide_1.6a9051cd.png";